import React, { useEffect, useState } from 'react'
import { Form, Input, Picker, TextArea, Checkbox, Button, CascadePicker } from 'antd-mobile'
import MobileField from './MobileField';
import { validatePhoneNumber } from '../../utils/FormatPhoneNumber/FormatPhoneNumber';
import { createBusinessClient } from '../../redux/actions/businessClient/businessClient';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../Common/Loading/Loading';
import { safeParse } from '../../utils/utility';

const genderOptions = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' },
    { label: 'Prefer not to say', value: 'Prefer not to say' }
];

const months = [
    { label: 'January', value: 'Jan', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'February', value: 'Feb', children: Array.from({ length: 29 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'March', value: 'Mar', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'April', value: 'Apr', children: Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'May', value: 'May', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'June', value: 'Jun', children: Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'July', value: 'Jul', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'August', value: 'Aug', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'September', value: 'Sep', children: Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'October', value: 'Oct', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'November', value: 'Nov', children: Array.from({ length: 30 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) },
    { label: 'December', value: 'Dec', children: Array.from({ length: 31 }, (_, i) => ({ label: `${i + 1}`, value: `${i + 1}` })) }
];

const ClientForm = (props) => {
    const [form] = Form.useForm()
    const [country, setCountry] = useState(safeParse("business")?.country || "CA");
    const dispatch = useDispatch();
    const { loading, message, client } = useSelector((state) => state.businessClient)

    const onFinish = (values) => {
        const businessClient = {
            ...values,
            birthday: values.birthday ? `${values.birthday[0]} ${values.birthday[1]}` : null,
            gender: values.gender ? values.gender[0] : null,
            notifyByEmail: true
        }
        dispatch(createBusinessClient(businessClient))
    }

    useEffect(() => {
        if (message && client) {
            props.setCurrentClient(client)
            props.setClientFormVisible(false)
            props.setVisible(false)
        }
    }, [message, client, props])


    if (loading) {
        return <Loading />
    }

    return (
        <div>
            <h1>Add New Client</h1>
            <Form
                style={{ marginTop: '30px' }}
                form={form}
                layout='horizontal'
                onFinish={onFinish}
                footer={
                    <Button block type='submit' color='primary' size='large' shape='rounded'>
                        Save
                    </Button>
                }
            >
                <Form.Item name='phone' label='Phone' rules={[
                    { required: true, message: 'Please enter phone number' },
                    ({ getFieldValue }) => ({
                        validator(rule, value) {

                            if (!value || validatePhoneNumber(value, country)) {
                                return Promise.resolve();
                            }

                            return Promise.reject(
                                "Please enter a valid phone number!"
                            );
                        },
                    }),
                ]}>
                    <MobileField form={form} setCountry={setCountry} country={country} />
                </Form.Item>
                <Form.Item name='firstName' label='First Name' >
                    <Input placeholder='Enter first name' />
                </Form.Item>
                <Form.Item name='lastName' label='Last Name' >
                    <Input placeholder='Enter last name' />
                </Form.Item>
                <Form.Item name='email' label='Email' rules={[
                    { type: 'email', message: 'Please enter a valid email' },
                ]}>
                    <Input placeholder='Enter email' />
                </Form.Item>
                <Form.Item
                    name='gender'
                    label='Gender'
                    trigger='onConfirm'
                    onClick={(e, picker) => {
                        picker.current?.open()
                    }}
                >
                    <Picker columns={[genderOptions]}>
                        {value => {
                            return (value && value[0]) ? value[0]?.label : <span style={{ color: "#cbcbcb" }}>Select gender</span>
                        }}
                    </Picker>
                </Form.Item>
                <Form.Item
                    name='birthday'
                    label='Birthday'
                    trigger='onConfirm'
                    onClick={(e, picker) => {
                        picker.current?.open()
                    }}
                >
                    <CascadePicker options={months}>
                        {val => {
                            return val && val[1] ? `${val[0].label} ${val[1].label}` : <span style={{ color: "#cbcbcb" }}>Select birthday</span>
                        }}
                    </CascadePicker>
                </Form.Item>
                <Form.Item name='note' label='Note'>
                    <TextArea placeholder='Add a note' rows={3} />
                </Form.Item>
                <Form.Item name='notifyByPhone' valuePropName='checked' initialValue={true}>
                    <Checkbox >Notify by phone</Checkbox>
                </Form.Item>
            </Form>
        </div>
    )
}

export default ClientForm